// extracted by mini-css-extract-plugin
export var skiptoinvisible = "SkipToContent-module--skiptoinvisible--18022";
export var skiptovisible = "SkipToContent-module--skiptovisible--70c82";